/* eslint-disable no-unused-vars */
import { useSelector, useDispatch } from 'react-redux';
import { manageCampaignsActions } from 'store/actions';
import { DateRange } from 'components';

export const ManageCampaignCalendar = () => {
  const dispatch = useDispatch();

  const timePeriod = useSelector((state) => state.manageCampaigns.selectedDateRange);
  const dateRangeName = useSelector((state) => state.manageCampaigns.dateRangeName);

  function updateRangeName(rangeName) {
    dispatch(manageCampaignsActions.updateDateRangeName(rangeName));
  }

  function updateTimeRange(fromDate, toDate) {
    dispatch(manageCampaignsActions.updateTimeRange({ from: fromDate, to: toDate }));
  }

  return (
    <DateRange
      dateFrom={timePeriod.from}
      dateTo={timePeriod.to}
      dateRangeName={dateRangeName}
      onUpdateRangeName={updateRangeName}
      onUpdateTimeRange={updateTimeRange}
    />
  );
};
